import { useParams } from 'react-router-dom';
import { useGetOne, useTranslate } from 'ra-core';
import { ResourcesValue } from '../resources';
import { CenteredSpinner } from '../../components/custom/CenteredSpinner';
import { MoonstarList } from '../Moonstar/MoonstarList';
import { MoonstarListActions } from '../Moonstar/MoonstarListActions';
import { BadgesAwardsList } from './BadgesAwardsList';
import { createListExporter } from './createListExporter';
import { BadgesAwardsChart } from './BadgesAwardsChart';
import { ListExportButton } from '../../components/custom/ListExportButton';
import { DateRangeInput } from '../../components/custom/DateRangeInput';

export const SingleBadgeAnalytics = () => {
  const { id } = useParams();
  const { data: badge, isPending } = useGetOne(ResourcesValue.BADGES, { id });
  const translate = useTranslate();

  const now = new Date();
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  const createdAfterDefault = firstDayOfMonth.toISOString().split('T')[0]!;
  const createdBeforeDefault = lastDayOfMonth.toISOString().split('T')[0]!;

  if (isPending || !id) {
    return <CenteredSpinner />;
  }

  return (
    <MoonstarList
      resource={ResourcesValue.BADGE_AWARDS}
      filter={{ badgesId: [id] }}
      filters={[
        <DateRangeInput
          key="awarded-on"
          startSource="createdAfter"
          endSource="createdBefore"
          alwaysOn
        />,
      ]}
      filterDefaultValues={{
        createdAfter: createdAfterDefault,
        createdBefore: createdBeforeDefault,
      }}
      sort={{ field: 'awardedOn', order: 'DESC' }}
      actions={
        <MoonstarListActions
          hideCreate
          right={<ListExportButton maxResults={Infinity} />}
        />
      }
      exporter={createListExporter(ResourcesValue.BADGE_AWARDS)}
      debounce={1000}
    >
      <BadgesAwardsChart
        name={badge.name}
        title={translate('moonstar.badges.analytics.singleBadgeTitle', {
          name: badge.name,
        })}
        badgeIdFilter={[id]}
      />
      <BadgesAwardsList />
    </MoonstarList>
  );
};
